export default __webpack_public_path__ + "static/media/pkb-4.b9c154d2.png";